import React from "react";
import Header from "../common/Header/header.jsx";
import Table from "../common/Table/table.jsx";
import Footer from "../common/Footer/footer.jsx";
import { specialLacturesData, teachingData } from "./teachingData.jsx";

const TeachingEngagementPage = () => {
  return (
    <>
      <Header />
      <div className="my-2">
        <Table
          tableHeadings={teachingData.teachingHeaders}
          tableData={teachingData.teachingDetails}
        />
        <Table
          tableHeadings={specialLacturesData.specialLacturesHeaders}
          tableData={specialLacturesData.specialLacturesDetails}
        />
      </div>
      <Footer />
    </>
  );
};

export default TeachingEngagementPage;
